import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';

export enum HEALTH_LOG_TYPE {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  DEBUG = 'debug'
}

export enum HEALTH_LOG_SOURCE {
  JIRA = 'jira',
  ATHENA = 'athena'
}

// this types will be doubled between backend and frontend
// couldn't we set up shared types?
export interface HealthLogItem {
  errorId: string;
  error: string;
  gsi_source: HEALTH_LOG_SOURCE;
  type: HEALTH_LOG_TYPE;
  tags: string[];
  createdAt: number;
  updatedAt: number;
}

export interface HealthLogsResponse {
  items: HealthLogItem[];
  count: number;
  lastKey: HealthLogItem | null;
}

const baseUrl = `${import.meta.env.VITE_BACKEND_URL}/api`;

export const healthApi = createApi({
  reducerPath: 'healthApi',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl }),
  tagTypes: ['health'],
  endpoints: (builder) => ({
    getBackendHealth: builder.query<{ status: string }, void>({
      query: () => '/health/'
    }),
    getBackendLogs: builder.query<HealthLogsResponse, { source: HEALTH_LOG_SOURCE; lastKey?: HealthLogItem | null }>({
      query: ({ source, lastKey }) => ({
        url: '/health-logs/',
        method: 'POST',
        body: {
          gsi_source: source,
          lastKey
        }
      })
    })
  })
});

export const { useGetBackendHealthQuery, useGetBackendLogsQuery } = healthApi;
